export default __webpack_public_path__ + "static/media/onboarding-app-logo-graphic.ed85b65a.svg";